export const MenuDots = () => (
    <>
        <rect y="3" width="4" height="4" rx="2" />
        <rect y="11" width="4" height="4" rx="2" />
        <rect y="19" width="4" height="4" rx="2" />
    </>
);

MenuDots.viewBox = '0 0 4 26';
